import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';

const client = axios.create({});

export default {
  /**
   *
   * @param param0
   */
  async request ({ headers, ...config }) {
    const mergedConfig = {
      ...config,

      headers: {
        ...headers,
      },
    };

    return client.request(mergedConfig);
  },

  /**
   *
   * @param url
   * @param data
   * @param config
   */
  post (url, data, config) {
    return this.request({
      method: 'post',
      url,
      data,
      ...config,
    });
  },

  /**
   *
   * @param url
   * @param config
   */
  get (url, config) {
    return this.request({
      method: 'get',
      url,
      ...config,
    });
  },

  /**
   *
   * @param url
   * @param data
   * @param config
   */
  put (url, data, config) {
    return this.request({
      method: 'put',
      url,
      data,
      ...config,
    });
  },

  /**
   *
   * @param url
   * @param data
   * @param config
   */
  patch (url, data, config) {
    return this.request({
      method: 'patch',
      url,
      data,
      ...config,
    });
  },

  /**
   *
   * @param url
   * @param config
   */
  delete (url, config) {
    return this.request({
      method: 'delete',
      url,
      ...config,
    });
  },
};
